import scanApi from '@/domains/scan/api/scan.api';

async function isPodonexReady(): Promise<boolean> {
    try {
        await scanApi.hello();
        return true;
    } catch {
        return false;
    }
}

export default isPodonexReady;
